module.exports = "/packs/images/homepage/facilities/tennis~eec236e4f87377495635b17675a77df5.jpg";